import { useCallback as o } from "react";
import { usePLMapboxStoreV2 as e } from "./index.es6.js";
const n = () => {
  const a = e(
    (t) => t.actions.setExternalLoadingStatus
  );
  return o(
    (t) => {
      a(t);
    },
    [a]
  );
};
export {
  n as useSetExternalLoadingStatus
};
//# sourceMappingURL=index.es202.js.map
